import { ICoordinateSystemInfoProvider, T_ICoordinateSystemInfoProvider } from '@cgs/common';
import { Container } from '@cgs/wge';
import { IconsSceneObjectWithScissor } from '../../reels_engine/icons_scene_object_with_scissor';
import { T_IReelsConfigProvider, RESOURCES_COMPONENT_TOKEN } from '../../type_definitions';
import { IconsSceneObjectComponent } from './icons_scene_object_component';
import { IReelsConfigProvider } from './interfaces/i_reels_config_provider';
import { ResourcesComponent } from './resources_component';

export class IconsSceneObjectWithScissorComponent extends IconsSceneObjectComponent {
  constructor(container: Container, drawWithPushState: boolean = true) {
    super(container, drawWithPushState);
    const reeslConfig = container.resolve<IReelsConfigProvider>(T_IReelsConfigProvider).reelsConfig;
    const coordinateProvider = container.resolve<ICoordinateSystemInfoProvider>(
      T_ICoordinateSystemInfoProvider
    )!;
    const res = container.resolve<ResourcesComponent>(RESOURCES_COMPONENT_TOKEN);
    const iconFrameStart = res.findStartReelNode(0);

    const iconsHolder = res.slot.findById('icons_holder');
    const animHolder = res.slot.findById('anim_icons_holder');

    iconsHolder?.removeChild(this.iconsRender);

    if (this.animIconsRender) {
      animHolder?.removeChild(this.animIconsRender);
    }

    this.iconsRender = new IconsSceneObjectWithScissor(
      drawWithPushState,
      container,
      reeslConfig,
      coordinateProvider
    );

    this.animIconsRender = new IconsSceneObjectWithScissor(
      drawWithPushState,
      container,
      reeslConfig,
      coordinateProvider
    );
    this.iconsRender.position = iconFrameStart.position;
    this.animIconsRender.position = iconFrameStart.position;

    iconsHolder?.addChild(this.iconsRender);

    if (this.animIconsRender) {
      animHolder?.addChild(this.animIconsRender);
    }
  }
}
